import React, { Fragment, useState, useEffect } from "react";
import { Box, Card, Stack, Typography } from "@mui/material";
import { ChatsList } from "./ChatsList";
import { usePage } from "@inertiajs/react";
import ChatMessages from "./ChatMessages";
import { getUserDetails } from "../../../config/apisauce";
import useStore from "../../../states/store";
import { ChatTeardropText } from "@phosphor-icons/react";
import { useMediaQuery, useTheme } from "@mui/material";

const ChatsPage = () => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down("md"));

  const { auth } = usePage().props;
  const [, { openLoader, closeLoader }] = useStore();
  const [creatorDetails, setCreatorDetails] = useState({});
  const [selectedChat, setSelectedChat] = useState(null);
  const [chatListModel, setChatListModel] = useState(0);

  const fetchCreatorDetails = async () => {
    openLoader();
    const { ok, data } = await getUserDetails({ user_id: auth?.user?.id });
    if (ok) {
      setCreatorDetails(data);
    }
    closeLoader();
  };

  useEffect(() => {
    fetchCreatorDetails();
  }, []);

  return (
    <Fragment>
      <Box sx={{ display: "flex", flexDirection: "row", height: "0px", gap: 1, flexGrow: 1 }}>
        {(!isSm || !selectedChat) && (
          <Card sx={{ flex: 1, p: 2, display: "flex", flexDirection: "column", height: "100%", overflowY: "auto" }}>
            <Typography variant="h6" color="primary.main" fontWeight={700}>
              Chats
            </Typography>
            <ChatsList
              userId={auth?.user?.id}
              senderDetails={selectedChat}
              setSelectedChat={setSelectedChat}
              selectedChat={selectedChat}
              chatListModel={chatListModel}
              setChatListModel={setChatListModel}
            />
          </Card>
        )}
        {(!isSm || selectedChat) && (
          <Card sx={{ flex: 2, p: 0, display: "flex", flexDirection: "column" }}>
            {selectedChat ? (
              <ChatMessages
                userId={auth?.user?.id}
                height={100}
                creatorDetails={creatorDetails}
                senderDetails={selectedChat}
                setChatListModel={setChatListModel}
                setSenderDetails={setSelectedChat}
                isSm={isSm}
              />
            ) : (
              <Box sx={{ display: "flex", height: "80vh", justifyContent: "center", alignItems: "center" }}>
                <Stack alignItems="center" gap={1} color="primary.main">
                  <ChatTeardropText size={48} weight="thin" />
                  <Typography variant="h6" fontWeight={700}>
                    Collab Chats
                  </Typography>
                  <Typography color="gray" fontWeight={400}>
                    Select a conversation to start chatting.
                  </Typography>
                </Stack>
              </Box>
            )}
          </Card>
        )}
      </Box>
    </Fragment>
  );
};

export default ChatsPage;
